import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { BenefitResponse } from "../../types/actionItem";
import { fetchActionModuleInstancesThunk, fetchActionModules } from "../thunk/actionsModulesThunk";
import { ActionModule } from "../../types/actionModule/actionModule";
import { ActionModuleInstanceResponse } from "../../types/actionModule/actionModuleInstance";

export interface ActionsInitialState {
  actionsData: ActionModule[];
  actionToEdit: ActionModule | Partial<ActionModule> | null;
  instances: ActionModuleInstanceResponse[];
  editMode: boolean
}

const initialState: ActionsInitialState = {
  actionsData: [],
  actionToEdit: null,
  instances: [],
  editMode: false
};

const actionsSlice = createSlice({
  name: "actions",
  initialState,
  reducers: {
    setActions: () => { },
    setEditedActionData: (state, action: PayloadAction<Partial<ActionModule>>) => {
      state.actionToEdit = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchActionModules.fulfilled, (state, action) => {
      if (!action.payload || !(action.payload as ActionModule[]).length) {
        state.actionsData = []
      } else {
        state.actionsData = action.payload as ActionModule[];
      }
    });
    builder.addCase(fetchActionModuleInstancesThunk.fulfilled, (state, action) => {
      state.instances = action.payload ?? [];
    });
  },
});

export const {
  setActions,
  setEditedActionData,
} = actionsSlice.actions;

export default actionsSlice.reducer;
